import moment from 'moment'
// import ft from '../featureToggle'

export default {
  getCards (VueApp, conId, callback) {
    let cards = VueApp.$store.state.consumer.creditCards
    let pageSize = cards.perPage
    let page = cards.currentPage

    VueApp.$sdk.get('/consumer/' + conId + '/cards', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1,
      order: 'created',
      orderAsc: 0
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setCardsCurrentPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setCardsIsMax', true)
        }

        if (res.list.length) {
          let cardInfo = res.list
          for (let i = 0; i < res.list.length; i++) {
            // let created = moment(cardInfo[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss')
            let created = moment.utc(cardInfo[i].created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm:ss')
            if (cardInfo[i].created === null) {
              created = 'N/A'
            }
            VueApp.$store.commit('consumer/addCards', {
              date: created,
              card: cardInfo[i].cardNumber,
              address: cardInfo[i].billingAddress,
              city: cardInfo[i].billingCity,
              state: cardInfo[i].billingState,
              zip: cardInfo[i].billingZip,
              status: cardInfo[i].verified
            })
          }
        }
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/credit-cards.js